import { CommunicatorService } from 'ui-ng-component-communicator';
import { BusyIndicatorService, HIDE_BUSY_INDICATOR_EVENT, SHOW_BUSY_INDICATOR_EVENT } from '../busy_indicator_srv';

class BusyIndicatorController {
  message: string = '';
  show: boolean = false;

  private showBusyIndicatorBound: () => void;
  private hideBusyIndicatorBound: () => void;

  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private ngBusyIndicatorService: BusyIndicatorService
  ) {
    this.showBusyIndicatorBound = this.showBusyIndicator.bind(this);
    this.hideBusyIndicatorBound = this.hideBusyIndicator.bind(this);
  }

  $onInit() {
    this.ngComponentCommunicatorService.subscribe(SHOW_BUSY_INDICATOR_EVENT, this.showBusyIndicatorBound);
    this.ngComponentCommunicatorService.subscribe(HIDE_BUSY_INDICATOR_EVENT, this.hideBusyIndicatorBound);
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release(SHOW_BUSY_INDICATOR_EVENT, this.showBusyIndicatorBound);
    this.ngComponentCommunicatorService.release(HIDE_BUSY_INDICATOR_EVENT, this.hideBusyIndicatorBound);
  }

  showBusyIndicator() {
    this.message = this.ngBusyIndicatorService.message;
    this.show = true;
  }

  hideBusyIndicator() {
    this.message = this.ngBusyIndicatorService.message;
    this.show = false;
  }
}

angular.module('capability-ng-academic-planner').component('busyIndicator', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/busy_indicator/components/busy_indicator.html',
  controller: BusyIndicatorController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/busy_indicator/components/busy_indicator.ts